<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Imaging and Biopsy Tests
        </h2>

        <div class="flex flex-col md:flex-row gap-4">
            <div class="p-6 flex-1">
                <h5 class="text-2xl font-semibold">Kidney imaging and biopsy test results</h5>
                <ul class="list-disc pl-4 font-light">
                    <li>
                        Kidney ultrasound showed <span class="font-semibold">bilateral cortical thinning</span> and <span class="font-semibold">marked echogenicity with pronounced corticomedullary differentiation</span>
                    </li>
                    <li>The medullary pyramids were diffusely echogenic, suggesting <span class="font-semibold">medullary nephrocalcinosis</span></li>
                    <li>Kidney biopsy revealed extensive deposition of <span class="font-semibold">calcium oxalate crystals</span></li>
                </ul>
            </div>

            <div class="divider-h bg-lightblue md:hidden"></div>
            <div class="divider-v bg-lightblue hidden md:block"></div>

            <div class="p-6 flex-1">
                <h5 class="text-2xl font-semibold">Skin biopsy test results</h5>
                <ul class="list-disc pl-4 font-light">
                    <li>
                        A leg punch biopsy of the skin and subcutis revealed mural deposits of <span class="font-semibold">refractile calcium oxalate crystals</span> (with blue-yellow birefringence under polarized light) in dermal and
                        subcutaneous vessels
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
.divider-v {
    width: 3px;
}

.divider-h {
    height: 3px;
}
</style>
